// Runtime configuration that doesn't depend on build-time env vars
// This ensures the correct API URL is used regardless of how the app is built

export const getApiUrl = () => {
  // Check if we're in production based on hostname
  const hostname = window.location.hostname;

  // Log for debugging (remove in production)
  console.log('Runtime config - Current hostname:', hostname);

  // Check for PREPROD first (more specific match)
  const isPreprod = hostname.includes('magi-preprod');

  if (isPreprod) {
    console.log('Runtime config - Using PREPROD API URL');
    return 'https://magi-video-generator-preprod-1025490770112.us-central1.run.app';
  }

  // Check for production domains
  const isProduction =
    hostname.includes('magi-f7f13.web.app') ||
    hostname.includes('magi-f7f13.firebaseapp.com') ||
    hostname.includes('firebaseapp.com') ||
    hostname.includes('magiacademy.com') ||
    hostname.includes('web.app'); // Generic Firebase hosting domain

  if (isProduction) {
    console.log('Runtime config - Using PRODUCTION API URL');
    return 'https://magi-video-generator-1025490770112.us-central1.run.app';
  }

  // Development/localhost
  console.log('Runtime config - Using DEVELOPMENT API URL');
  return 'http://localhost:8765';
};

// Export the API URL as a function so it's always evaluated at runtime
export const API_BASE_URL = getApiUrl();

// Export a function to get the URL dynamically (useful for debugging)
export const getRuntimeApiUrl = getApiUrl;

// Stripe public key configuration - secure environment-based loading
export const getStripePublicKey = () => {
  const hostname = window.location.hostname;
  const isProduction =
    hostname.includes('magi-f7f13.web.app') ||
    hostname.includes('firebaseapp.com') ||
    hostname.includes('magiacademy.com') ||
    hostname.includes('web.app');

  if (isProduction) {
    // Production Stripe key from environment
    const prodKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY_LIVE;
    if (!prodKey) {
      console.error('❌ CRITICAL: VITE_STRIPE_PUBLIC_KEY_LIVE not configured');
      throw new Error('Stripe public key not configured for production');
    }
    return prodKey;
  }

  // Test Stripe key for development from environment
  const testKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY_TEST;
  if (!testKey) {
    console.error('❌ CRITICAL: VITE_STRIPE_PUBLIC_KEY_TEST not configured');
    throw new Error('Stripe public key not configured for development');
  }
  return testKey;
};

// Firebase configuration - secure environment-based loading
export const getFirebaseConfig = () => {
  // Required Firebase configuration fields
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
  };

  // Validate required fields
  const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
  const missingFields = requiredFields.filter(field => !config[field]);

  if (missingFields.length > 0) {
    console.error('❌ CRITICAL: Missing Firebase configuration:', missingFields);
    throw new Error(`Firebase configuration incomplete. Missing: ${missingFields.join(', ')}`);
  }

  return config;
};

// Export the config for backwards compatibility (will be dynamically loaded)
export const FIREBASE_CONFIG = getFirebaseConfig();